var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7528\u6237\u5206\u5C42-\u672A\u9009@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0903\\u4FEE\\u6539",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-228.000000, -483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(199.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21",
    transform: "translate(13.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u5206\\u5C42-\\u672A\\u9009",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1 L14,1 L14,1 L18,5 L18,18 C18,18.5522847 17.5522847,19 17,19 L3,19 C2.44771525,19 2,18.5522847 2,18 L2,2 C2,1.44771525 2.44771525,1 3,1 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E9E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,1 L18,5 L15,5 C14.4477153,5 14,4.55228475 14,4 L14,1 L14,1 Z",
    id: "\\u77E9\\u5F62",
    fill: "#B5B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11 C11.5321652,11 12.9328289,11.8656578 13.618034,13.236068 L14.2763932,14.5527864 C14.5233825,15.0467649 14.3231581,15.6474379 13.8291796,15.8944272 C13.6903242,15.9638549 13.5372111,16 13.381966,16 L6.61803399,16 C6.06574924,16 5.61803399,15.5522847 5.61803399,15 C5.61803399,14.8447549 5.65417908,14.6916418 5.7236068,14.5527864 L6.38196601,13.236068 C7.0671711,11.8656578 8.46783484,11 10,11 Z",
    id: "\\u77E9\\u5F62",
    fill: "#B5B5C3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 10,
    cy: 8,
    r: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/buyer.82557a5f.svg";
export { ForwardRef as ReactComponent };